export default "__VITE_ASSET__BuTeOTkb__"